module.exports = __webpack_public_path__ + "img/93-ef16c8.png";